import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import FieldZoneIcon from 'components/FieldZoneIcon';
import { DRAWER_DIMENSIONS } from '../../constants';

interface DrawerFooterProps {
  totalCropZones: number;
  totalArea: number;
  onClose: () => void;
}

/**
 * Footer component for ViewOnMapDrawer
 * Displays summary statistics and close button
 */
const DrawerFooter: React.FC<DrawerFooterProps> = ({
  totalCropZones,
  totalArea,
  onClose
}) => {
  return (
    <footer
      className="flex justify-between items-center border-t border-neutral-20 px-6 gap-3 shrink-0 bg-white -mx-6"
      style={{ height: DRAWER_DIMENSIONS.FOOTER_HEIGHT }}
    >
      <div className="flex flex-row items-center">
        <div className="mr-1">
          {`${totalCropZones} total crop zone${
            totalCropZones === 1 ? '' : 's'
          }`}
        </div>
        <div className="ml-2 flex items-center">
          <FieldZoneIcon />
          <span>
            {totalArea.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}{' '}
            total ac
          </span>
        </div>
      </div>
      <Button type={ButtonType.outline} size="large" onClick={onClose}>
        Close
      </Button>
    </footer>
  );
};

export default DrawerFooter;
